<template>
  <div>
    <van-nav-bar title="我的意见建议" />
    <!-- 
      
      
     -->
    <el-card shadow="always"
    
    v-for="(onecontent, i) in mySuggestions"
    :key="i"
      >
      <div slot="header" class="clearfix">
        <span style="float: left;">{{onecontent.typeLabel}}</span>
        <el-button style="float: right; padding: 3px 0" type="text">{{onecontent.statusLabel}}</el-button>
      </div>
      <div class="text">
      {{onecontent.content}}
      </div>
    </el-card>

    <div style="height:80px;"></div>
    <mTabbar></mTabbar>
  </div>
</template>

<script>
import mTabbar from '../components/TabBar'

import store from '../store'
import $ from "jquery"
import { Row, Col, Icon, Cell, CellGroup } from 'vant';

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    mTabbar
  },
  data() {
    return {
      mySuggestions: [],
    };
  },
  created: function () {
    this.getContent();
  },
  methods: {
    getContent: function () {
      let APIBASEURL = "https://www.gongdiangonghui.cn";
      const _this = this;
      $.ajax({
        cache: false,
        contentType: "application/json",
        dataType: "json",
        type: "POST",  
        url: APIBASEURL + "/suggestion/userListSuggestion?page=0&pageSize=50",
        data: JSON.stringify({
          jwt: store.state.jwt
        }),
        async: false,
        // beforeSend: function (XMLHttpRequest) {
        //				XMLHttpRequest.setRequestHeader("authorization", storage["yuekejwt"]);
        //			},
        error: function (request) {
          alert("发送请求失败" + JSON.stringify(request));
        },
        success: function (response) {
          // alert("成功，response是:" + JSON.stringify(response));
          // {"contentType":0,"contentid":4,"createtime":"2020-03-06 15:31:02","id":13,"image":"http://cdn.learningpartner.club/trade/common/1/e75c4044-ac65-428e-a8a3-d942a8f478b3","isForIndex":true,"sort":9,"title":"测试多个文章2","type":"测试"}
          if (response.code != "200") {
            if (response.msg == "no user info related weixin") {
              _this.$router.push('/registry');
            } else {
              alert("返回错误信息" + response.msg);
            }
          } else {
            //  alert("成功，response是:" + JSON.stringify(response.data.content));
            for (var i = 0; i < response.data.content.length; i++) {
                if(response.data.content[i].type == "0"){
                  response.data.content[i].typeLabel = "系统建议";
                }else{
                  response.data.content[i].typeLabel = "留言信箱";
                }

                if(response.data.content[i].status){
                  response.data.content[i].statusLabel = "已阅读";
                }else{
                  response.data.content[i].statusLabel = "未阅读";
                }

             }
            _this.mySuggestions = response.data.content;
          }
        },
      });
    }
  }
};
</script>

<style lang="less" scoped>
.el-card {
  margin-top: 10px;
  margin-right: 10px;
  margin-left: 10px;
}
.text {
  font-size: 14px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>